export const removePageClassContent = (className) => {
    [].forEach.call(
        document.querySelectorAll(className),
        (target) => {
            target.style.display = 'none';
        }
    );
}
